export default __webpack_public_path__ + "static/media/down-small.f397b4dd.svg";